// extracted by mini-css-extract-plugin
module.exports = {"root":"InfoRow_root__3atRL","left":"InfoRow_left__3KVnL"};